import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface ResendIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const ResendIcon = ({ className, ...props }: ResendIconProps) => (
  <svg
    className={cn("text-light-400", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6 8L10.5 11L15 8"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M12 18L3.46259 18C2.35802 18 1.46259 17.1046 1.46259 16V6C1.46259 4.89543 2.35802 4 3.46259 4L17 4C18.1046 4 19 4.89543 19 6V8"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="1.5"
    />
    <path
      d="M22.6669 15.6667C22.0481 14.097 20.635 13 18.9906 13C17.2322 13 15.7382 14.2545 15.1973 16"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.3"
    />
    <path
      d="M20.9951 15.7723H22.4001C22.7314 15.7723 23.0001 15.5036 23.0001 15.1723V13.55"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.3"
    />
    <path
      d="M15.3341 18.3333C15.9529 19.903 17.366 21 19.0103 21C20.7687 21 22.2628 19.7455 22.8037 18"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.3"
    />
    <path
      d="M17.0049 18.2277H15.5999C15.2686 18.2277 14.9999 18.4964 14.9999 18.8277V20.45"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.3"
    />
  </svg>
);

export default ResendIcon;
